import "../../styles/components/atoms/LogSelect.scss";
import PropTypes from "prop-types";
import { CheckPicker } from "rsuite";
import styled from "styled-components";
import { getTypeTruck } from "../../utils/helpers";

const SelectPickerMultiStyled = styled(CheckPicker)`
  background-color: white;
  border: none;
  padding: 1px 1px;
  border-radius: 6px;
  box-shadow: 0px 0px 5px #cccccc;
  height: 40px;
  display: flex;
  align-items: center;
`;

const DivItem = styled.div`
  display: flex;
  align-items: center;
`;

const FooterBtn = styled.div`
  padding: 10px;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  border-top: 1px solid #eee;

  &:hover {
    background: #f7f7f7;
  }
`;

const LogSelectMultiCustomAll = ({
  items,
  className,
  errors,
  name,
  iconLogName,
  searchable = false,
  cleanable,
  value = [],
  onChange,
  ...rest
}) => {
  const allValues = items.map((i) => i.value);
  const allSelected = value.length === items.length;

  const handleToggleAll = () => {
    if (allSelected) {
      onChange([]); // deseleccionar todos
    } else {
      onChange(allValues); // seleccionar todos
    }
  };

  return (
    <>
      <SelectPickerMultiStyled
        className={className + " mt-1"}
        cleanable={cleanable}
        name={name}
        data={items}
        searchable={searchable}
        block
        value={value}
        onChange={onChange}
        {...rest}
        renderMenuItem={(label, item) => (
          <DivItem>
            {iconLogName && (
              <div className="circle-icon-list">
                <span className={iconLogName + " text-primary"}></span>
              </div>
            )}
            <strong>{label}</strong>&nbsp;
            {item?.truck_type && getTypeTruck(item.truck_type)}
          </DivItem>
        )}
        renderExtraFooter={() => (
          <FooterBtn onClick={handleToggleAll}>
            {allSelected ? "Deseleccionar todos" : "Seleccionar todos"}
          </FooterBtn>
        )}
      />

      {errors[name] && (
        <div className="mb-2 mt-0">
          <small className="text-danger">{errors[name]}.</small>
        </div>
      )}
    </>
  );
};

LogSelectMultiCustomAll.propTypes = {
  items: PropTypes.array.isRequired,
};

export default LogSelectMultiCustomAll;
